import { logger } from "@jslib/shared/utils/logger";

import { type DatabaseId } from "../../types/types";

export const ensureTrailingSlash = (url: string) => url.replace(/\/?$/, "/");

export const getQueryParamsFromUrl = (url?: string) => {
  const newUrl = new URL(url || window.location.toString());
  return new URLSearchParams(newUrl.search.slice(1));
};

export const getQueryParam = (paramKey: string, url?: string) =>
  getQueryParamsFromUrl(url).get(paramKey);

export const getVerificationIdFromQueryString = (queryString: string): DatabaseId => {
  const verificationIdQueryParameter: string = "verificationId";
  const queryStringParameters: URLSearchParams = new URLSearchParams(queryString);
  const verificationId: DatabaseId = queryStringParameters.get(verificationIdQueryParameter);
  if (typeof verificationId === "string" && verificationId.length === 0) {
    return null;
  }
  return verificationId;
};

export const getTrackingIdFromQueryString = (queryString: string): string => {
  const trackingIdQueryParameter: string = "trackingId";
  const queryStringParameters: URLSearchParams = new URLSearchParams(queryString);
  const trackingId: DatabaseId = queryStringParameters.get(trackingIdQueryParameter);
  if (typeof trackingId === "string" && trackingId.length === 0) {
    return null;
  }
  return trackingId;
};

export const getDomainFromUrl = (url: string) => {
  let domain = url;
  try {
    domain = new URL(url).hostname;
  } catch (e) {
    logger.warn(e);
  }
  return domain.replace(/(www\.)?/, "");
};

// True only for absolute http(s) URLs. Use before handing an untrusted value
// (e.g. a server-supplied redirectUrl) to a navigation sink such as an href or
// window.open, so schemes like javascript: or data: are never navigated to.
export const isValidHttpUrl = (url: string | URL | null | undefined): boolean => {
  if (!url) return false;
  try {
    const { protocol } = new URL(url);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
};

export const redirectTo = (path: string) => {
  document.location.href = path;
};

export const getDomainFromEmail = (email: string) => {
  const emailAtIndex = email.indexOf("@");
  if (emailAtIndex === -1) {
    logger.error("Invalid email address");
  }
  return email.slice(emailAtIndex + 1);
};
